import { useEffect, useState } from "react"
import { Button } from "@/components/ui/button"
import { Card } from "@/components/ui/card"
import { PageLayout } from "./PageLayout"

interface FinalReflectionProps {
  onContinue: () => void
}

export function FinalReflection({ onContinue }: FinalReflectionProps) {
  const [showButton, setShowButton] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowButton(true)
    }, 5000)

    return () => clearTimeout(timer)
  }, [])

  return (
    <PageLayout>
      <div className="w-full max-w-4xl relative">
        <div className="space-y-6">
          <Card className="p-12 md:p-16 shadow-[0_20px_60px_-15px_rgba(0,0,0,0.3)] bg-white border-2 border-gray-300 text-center">
            <div className="space-y-6">
              <p className="text-lg md:text-xl text-gray-600 font-medium">
                Antes de mostrar o seu resultado:
              </p>

              <div className="space-y-5 py-6">
                <h2 className="text-3xl md:text-4xl font-bold text-title-blue">
                  Momento de Silêncio Consciente
                </h2>

                <div className="space-y-4 text-gray-700 leading-relaxed max-w-2xl mx-auto">
                  <p className="text-xl">Feche os olhos.</p>
                  <p className="text-xl">Inspire profundamente... segure o ar...</p>
                  <p className="text-xl">Expire devagar e conte mentalmente 25Segundos.</p>
                  <p className="text-xl font-semibold">Sinta-se presente.</p>
                  <p className="text-xl italic mt-6 text-gray-600">
                    Você não é apenas o que faz — você é o que sente, o que entende e o que escolhe realizar.
                  </p>
                </div>
              </div>

              <div className="pt-8 min-h-[100px] flex items-center justify-center">
                {showButton ? (
                  <Button
                    onClick={onContinue}
                    size="lg"
                    className="bg-gradient-primary hover:opacity-90 transition-all text-white text-lg px-10 py-7 h-auto shadow-glow font-bold rounded-xl hover:scale-105 animate-fade-in"
                  >
                    Ver Meu Resultado
                  </Button>
                ) : (
                  <p className="text-muted-foreground text-sm italic">
                    Aguarde um momento de reflexão...
                  </p>
                )}
              </div>
            </div>
          </Card>
        </div>
      </div>
    </PageLayout>
  )
}
